import { Type, type Static } from "@sinclair/typebox";

export const RecoveryAccountsQuerySchema = Type.Object(
  {
    managementYear: Type.Optional(
      Type.Integer({ minimum: 2000, maximum: 2200, default: 2026 }),
    ),
    administratorId: Type.Optional(Type.String({ format: "uuid" })),
    includeZero: Type.Optional(Type.Boolean({ default: false })),
  },
  { additionalProperties: false },
);

export const RecoveryRecalculateSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    jobVersion: Type.Integer({ minimum: 1 }),
  },
  { additionalProperties: false },
);

export const ManualRecoveryAccrualSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    jobVersion: Type.Integer({ minimum: 1 }),
    amount: Type.Number({ exclusiveMinimum: 0, maximum: 999_999_999_999.99 }),
    notes: Type.Optional(Type.String({ maxLength: 2000 })),
  },
  { additionalProperties: false },
);

export type ManualRecoveryAccrual = Static<typeof ManualRecoveryAccrualSchema>;

export type RecoveryAccountsQuery = Static<typeof RecoveryAccountsQuerySchema>;
export type RecoveryRecalculate = Static<typeof RecoveryRecalculateSchema>;

export interface AdministratorRecoveryEntry {
  id: string;
  entryType: "opening-balance" | "margin-gap" | "adjustment" | "manual-accrual";
  sourceJobId: string | null;
  sourceJobCode: string | null;
  occurredOn: string;
  amountDelta: string;
  notes: string | null;
  createdAt: string;
}

/** Historical costs are already in company totals; they do not add recovery credit. */
export interface AdministratorRecoveryHistoricalAmounts {
  laborAmount: string;
  materialAmount: string;
  costAmount: string;
  includedRevenueAmount: string;
}

export interface AdministratorRecoveryAccount {
  id: string;
  administratorId: string;
  administratorName: string;
  managementYear: number;
  targetMarginRate: string;
  creditedAmount: string;
  recoveredAmount: string;
  reservedAmount: string;
  balanceAmount: string;
  availableAmount: string;
  version: number;
  updatedAt: string;
  entries: AdministratorRecoveryEntry[];
  historicalAmounts?: AdministratorRecoveryHistoricalAmounts | null;
}

export interface AdministratorRecoveryPage {
  items: AdministratorRecoveryAccount[];
}
